import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { ServiceItem } from "@/services/entities/ServiceItem";
import { showWarning } from "@/toastification";
import DxDataGrid, {
  DxColumn,
  DxFilterRow,
  DxPaging, DxPager,
  DxHeaderFilter,
  DxStateStoring,
  DxButton
} from "devextreme-vue/data-grid";
import { ref } from "vue";
import { configureDataGridColumnsOrder } from "@/common/util";
import { useUserStore } from "@/stores/user";
import { UserRole } from "@/services/entities/UserItem";
import TeamIcon from "../util/TeamIcon.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ServiceTable',
  props: {
  data: { Type: [] as ServiceItem[], default: [] as ServiceItem[] },
},
  emits: ["detail", "teams"],
  setup(__props, { emit: __emit }) {

const userStore = useUserStore();
const emit = __emit;
const selectedKeys = ref([] as number[]);

const props = __props;

let isConfigured = false;

function  onContentReady(e: any) {
  // ensure default column order
  const defaultOrder = ['id', 'blServiceName', 'blpgCode', 'poNumber', 'country.name', 'isActive', 'buttons'];
  if (!isConfigured) {
    configureDataGridColumnsOrder(e, defaultOrder);
    isConfigured = true;
  }
};

function showDetail(e: any) {
  selectedKeys.value = [e.row.data.id];
  emit("detail", e.row.data.id);
}

function openLink(e: any) {
  let url = e.row.data.link;
  if (url) {
    if (!url.startsWith("http://") && !url.startsWith("https://")) {
      url = "https://" + url;
    }
    window.open(url, "_blank");
  }
  else {
    showWarning("No link available");
  }
}

function openTeams(e: any) {
  selectedKeys.value = [e.row.data.id];
  emit("teams", e.row.data.id);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(DxDataGrid), {
    "hover-state-enabled": true,
    "show-borders": false,
    "data-source": props.data,
    id: "serviceGridContainer",
    "selected-row-keys": selectedKeys.value,
    "auto-navigate-to-focused-row": true,
    "key-expr": "id",
    onContentReady: onContentReady
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(DxFilterRow), { visible: true }),
      _createVNode(_unref(DxHeaderFilter), { visible: true }),
      _createVNode(_unref(DxStateStoring), {
        enabled: true,
        type: "localStorage",
        "storage-key": "serviceGridContainer"
      }),
      _createVNode(_unref(DxColumn), {
        "data-field": "id",
        "data-type": "string",
        caption: "ID",
        visible: false
      }),
      _createVNode(_unref(DxColumn), {
        "data-field": "blServiceName",
        "data-type": "string",
        caption: "Name"
      }),
      _createVNode(_unref(DxColumn), {
        "data-field": "blpgCode",
        "data-type": "string",
        caption: "BL PG Code"
      }),
      _createVNode(_unref(DxColumn), {
        "data-field": "poNumber",
        "data-type": "string",
        caption: "PO number"
      }),
      _createVNode(_unref(DxColumn), {
        "data-field": "country.name",
        "data-type": "string",
        caption: "Country"
      }),
      _createVNode(_unref(DxColumn), {
        "data-field": "isActive",
        "data-type": "boolean",
        caption: "Active",
        width: 90
      }),
      _createVNode(_unref(DxColumn), {
        type: "buttons",
        caption: "Actions",
        width: _unref(userStore).getUserRole === _unref(UserRole).Administrator ? 105 : 70
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(DxButton), {
            hint: "View detail",
            icon: "eyeopen",
            "styling-mode": "contained",
            type: "normal",
            onClick: showDetail
          }),
          (_unref(userStore).getUserRole === _unref(UserRole).Administrator)
            ? (_openBlock(), _createBlock(_unref(DxButton), {
                key: 0,
                hint: "Teams",
                "styling-mode": "contained",
                type: "normal",
                onClick: openTeams
              }, {
                default: _withCtx(() => [
                  _createVNode(TeamIcon)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_unref(DxButton), {
            hint: "Open link",
            icon: "link",
            "styling-mode": "contained",
            type: "normal",
            onClick: openLink
          })
        ]),
        _: 1
      }, 8, ["width"]),
      _createVNode(_unref(DxPaging), { "page-size": 10 }),
      _createVNode(_unref(DxPager), {
        "show-page-size-selector": true,
        "allowed-page-sizes": [5, 10, 20]
      })
    ]),
    _: 1
  }, 8, ["data-source", "selected-row-keys"]))
}
}

})